import { RefObject, useEffect } from "react";

export const useGoogleAd = (ref: RefObject<HTMLModElement | null>) => {
  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    const executeWindowAds = () => {
      if (window.adsbygoogle && !ref.current?.hasChildNodes()) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error: any) {
          console.error("error ads======>", error.message);
        }
      }
    };

    if (!window.adsbygoogle || !window.adsbygoogle.loaded) {
      // Poll every 100ms to check if adsbygoogle is loaded
      intervalId = setInterval(() => {
        if (window.adsbygoogle && window.adsbygoogle.loaded) {
          executeWindowAds();
          clearInterval(intervalId);
        }
      }, 100);
    } else {
      executeWindowAds();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
